import Cookies from "js-cookie";

/**
 * Retrieves the JSESSIONID from the "portalSession" cookie.
 * @returns {string|null} The JSESSIONID or null if an error occurs.
 */
export const getjSessionId = () => {
    try{
        const portalSessionObject = JSON.parse(Cookies.get("portalSession"))
        return portalSessionObject?.pJSESSIONID;
    }catch(e){
        console.error(e);
    }
}

/**
 * Converts a string to camel case (or Pascal case) format. 
 * @param {string} str The string to be converted.
 * @returns {string|null} The camel cased string or null if the input string is empty or null.
 */
function camelCaseString(str){
  if(str && str.length > 0) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase(); 
  } else {
    return null;
  }
}

/**
 * Sets user attributes to PostHog for tracking and filtering purposes.
 * Retrieves the First Name, Last Name and JSESSIONID from the window object and sets them as attributes.
 * Also sets a quoteStartTimeStamp attribute if the window.ph_is_quote_start property is set to true.
 * If the window.posthog object is available and the user's first and last name are defined, 
 * it will call the posthog.identify function to set the attributes.
 * @returns {void}
 */
export function postHogUserAttributesTracking() {
  var postHogAttributes = {};

  if (window.ph_first_name) {
    var firstName = camelCaseString(window.ph_first_name);
    postHogAttributes["First Name"] = firstName;
    postHogAttributes["name"] = firstName;
  }

  if (window.ph_last_name) {
    var lastName = camelCaseString(window.ph_last_name);
    postHogAttributes["Last Name"] = lastName;
    postHogAttributes["name"] += " " + lastName;
  }

  if (window.customer_age) {
    postHogAttributes["Customer Age"] = window.customer_age;
  }

  postHogAttributes["JSESSIONID"] = getjSessionId();

  if (window.ph_is_quote_start) {
    postHogAttributes["quoteStartTimeStamp"] = (new Date().toLocaleString());
    window.ph_is_quote_start = false;
  }

  if (window.posthog && window.ph_first_name && window.ph_last_name) {
    window.posthog.identify(
      window.posthog.get_distinct_id(),
      postHogAttributes
    );
  }
}
